import styled from 'styled-components';

import Chevron from '../../../../assets/Chevron';
import zIndexLayers from '../../../../services/ZIndexLayers/ZIndexLayers';
import { ThemeProp } from '../../../../theme/Themes';
import IconButton from '../../../Button/IconButton';
import {
  drawerEasingFunction,
  drawerTransitionDuration,
  MIN_WIDTH_EXPANDABLE,
  WithOpenState,
} from './BaseDrawerLayout.styles';

interface StyledChevronIconProps extends WithOpenState {}
export const StyledChevronIcon = styled(Chevron)<StyledChevronIconProps>`
  stroke: ${({ theme }: ThemeProp) => theme.colors.primary.c300};
  transform: ${({ $isOpen }: StyledChevronIconProps) => ($isOpen ? 'rotate(90deg)' : 'rotate(270deg)')};
  transition: transform ${drawerTransitionDuration} ${drawerEasingFunction};
`;

export const ToggleButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 1rem;
  width: 1.25rem;
  height: 1.25rem;
  transform: translate(50%, 50%);
  z-index: ${zIndexLayers.drawer + 1};
  @media (max-width: ${MIN_WIDTH_EXPANDABLE}) {
    display: none;
  }
`;

export const ToggleButton = styled(IconButton)`
  background-color: ${({ theme }: ThemeProp) => theme.colors.greyscale.c900};
  border: solid 1px ${(props: ThemeProp) => props.theme.colors.greyscale.c700};
  width: 1.25rem;
  height: 1.25rem;

  svg {
    stroke: ${(props: ThemeProp) => props.theme.colors.primary.c300};
  }

  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.primary.ca500};
    border: solid 1px transparent;

    svg {
      stroke: ${(props: ThemeProp) => props.theme.colors.greyscale.c900};
    }
  }
`;
